import { Navigate, useLocation } from 'react-router';
import { useAuth } from './context';
import LoadingPage from '../pages/LoadingPage';
import type { DvmsRole } from './types';
import { ROUTES } from '../constants';

interface RequireAuthProps {
    children: React.ReactNode;
    /** Optional: required roles (any match grants access) */
    roles?: DvmsRole[];
}

export function RequireAuth({ children, roles }: RequireAuthProps) {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === 'loading') {
        return <LoadingPage />;
    }

    if (status === 'unauthenticated') {
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
    }

    if (roles && roles.length > 0 && user) {
        const hasRole = roles.some((role) => user.roles.includes(role));
        if (!hasRole) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h1>Access Denied</h1>
                    <p>You do not have permission to access this page.</p>
                </div>
            );
        }
    }

    return <>{children}</>;
}
